import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import {deleteLabel, editLabel} from '../actions';

import customer from '../../customer';
const {isDemoUser} = customer.selectors;

class LabelHover extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mouseDown: false
    };
  }

  handleMouseDown = () => {
    this.setState({mouseDown: true});
  }

  handleMouseUp = () => {
    this.setState({mouseDown: false});
  }

  handleMouseMove = () => {
    if(this.state.mouseDown) {
      this.props.onMouseDown();
    }
  }

  handleMouseLeave = () => {
    this.setState({mouseDown: false});
    this.props.onMouseLeave();
  }

  render() {
    const {actions, index, isDemoUser} = this.props;
    return (
      <div className="label-overlay" 
           onMouseDown={this.handleMouseDown}
           onMouseUp={this.handleMouseUp}
           onMouseMove={this.handleMouseMove} 
           onMouseLeave={this.handleMouseLeave}
      >
        <div className="btn-row">
        {!isDemoUser && <div className="btn-edit" onClick={() => {actions.editLabel(index);}}/>}
          <div className="btn-delete" onClick={() => {actions.deleteLabel(index);}} />
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({deleteLabel, editLabel}, dispatch)
  };
}

function mapStateToProps(state) {
  return {
    isDemoUser: isDemoUser(state)
  };
}

LabelHover.propTypes = {
  actions: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onMouseDown: PropTypes.func.isRequired,
  onMouseLeave: PropTypes.func.isRequired,
  isDemoUser: PropTypes.bool.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(LabelHover);


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/LabelHover.js
 **/